import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { ActionInput } from '../../common/ActionInput';
import styles from './styles.module.scss';

export const ClientAdminUserTableFilter: React.FC = () => {
  const [filterParams, setFilterParams] = useSearchParams();
  const updateFilterParams = (key: string, value: string) => {
    const newParams = new URLSearchParams(filterParams);
    if (value) {
      newParams.set(key, value);
    } else {
      newParams.delete(key);
    }
    // 再検索時にページネーションをリセット
    if (newParams.has('page')) {
      newParams.delete('page');
    }
    setFilterParams(newParams);
  };

  return (
    <div className={styles.root}>
      <div className={styles.form}>
        <label htmlFor='full_name' className={styles.formTitle}>
          名前
        </label>
        <ActionInput
          id='full_name'
          defaultValue={filterParams.get('full_name') ?? ''}
          action={e => updateFilterParams('full_name', e.target.value)}
          placeholder='福利 くらら'
        />
      </div>
      <div className={styles.form}>
        <label htmlFor='client_name' className={styles.formTitle}>
          会社名
        </label>
        <ActionInput
          id='client_name'
          defaultValue={filterParams.get('client_name') ?? ''}
          action={e => updateFilterParams('client_name', e.target.value)}
          placeholder='福利株式会社'
        />
      </div>
    </div>
  );
};
